import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Label,Input } from "reactstrap";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import Breadcrumbs from '../../components/Common/Breadcrumb'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
});

export default function Track() {

    const [coordinates, setCoordinates] = useState([]);
    const[email, setEmail] = useState("");
    const[storeID, setStoreid] = useState('');
    const[search, setSearch] = useState('')

    useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])


  useEffect(()=>{
    const fetchData=async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/coordinates?store=${storeID}`)

        const data = await res.json();
        setCoordinates(data)
    }

    if(storeID){
        fetchData();
    }

  },[storeID])
  const fetchOrders=async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/coordinates?store=${storeID}`)

        const data = await res.json();
        setCoordinates(data)
    }



  useEffect(()=>{
    const searchOrder =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/searchCoordinates?store=${storeID}&search=${search}`);
        const data = await res.json();
        setCoordinates(data)

    }

    if(search){
        searchOrder();
    }

    if(search == ''){
        fetchOrders();
    }
  },[storeID,search])




  return (
    <div className='ordersContainer'>
        <Breadcrumbs title="Easybox" breadcrumbItem="Track orders" />
        <div className="card" style={{padding:'10px'}}>
        <div className="searchBar">
            <div className="mb-4">
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>

        <div style={{ height: "80vh" }}>
      <MapContainer center={[-1.28333, 36.81667]} zoom={12} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        />
        {coordinates.map((coord, index) => (
          <Marker key={index} position={[coord.lat, coord.lng]}>
            <Popup>
              <strong>Order Number:</strong> {coord.orderNumber} <br />
              <strong>Latitude:</strong> {coord.lat}, <strong>Longitude:</strong> {coord.lng}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
        </div>
    </div>
  )
}
